<template>
  <div>
    <main id="#main" class="u-mt30">
      <div class="c-card-default c-documents">
        <p>
            送信が完了しました。
        </p>
      </div>
    </main>
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'
import { Mixin } from '@/mixin'

export default {
  name: 'app',
  components: {
    Footer
  },
  head: {
    title: function () {
      return {
        inner: '送信完了',
        separator: '|',
        complement: 'memorii'
      }
    }
  },
  beforeRouteEnter (route, redirect, next) {
    next(async vm => {
      const promises = []
      vm.$store.commit('SET_LOADING', true)
      await Promise.all(promises).then(function () {
        vm.$store.commit('SET_LOADING', false)
      })
    })
  },
  mixins: [Mixin]
}
</script>
